import { MapContainer, TileLayer, useMap, Marker, Circle,useMapEvents, Polygon } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L, { map } from "leaflet";
import "./map-component-style.css";
import Routing from "./Routing";
import { useEffect, useState,useRef } from "react";
import { NewAllCoordinates } from "./NewAllCoordinates";
// https://docs.stadiamaps.com/tutorials/getting-started-with-react-leaflet/
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

/**
 *
 * @param {*} params
 * @returns
 *
 * Usage:
 * const position = [35.700175, 51.354803]
 * IMPORTANT: use a parent div and give that div a height
 * <div className="h-[300px]">
 *  <MapWithSingleMarker position={position} zoom="15"></MapWithSingleMarker>
 * </div>
 */

function MapWithSingleMarker(params) {


  const [clickedCoords, setClickedCoords] = useState(params?.position || []);
  const [userCurrentLoc, setUserCurrentLoc] = useState([params?.userCurrentLoc])
  const [isFullscreen,setIsFullScreen] = useState(false)
  const allCoordinates = NewAllCoordinates;
  const [polygonForMap, setPolygonForMap] = useState([]);
  const mapRef = useRef();

  const MapClickHandler = () => {
    useMapEvents({
      click: (e) => {
        const { lat, lng } = e.latlng;
        setClickedCoords([lat, lng]); // Update local state
        if (params.onMapClick) {
          params.onMapClick([lat, lng]); // Pass coordinates to parent
        }
      },
    });
    return null;
  };

  // Fly to Province
  function FlyToProvince({ selectedProvinceId }) {
    const map = useMap();
    useEffect(() => {
      const targetCoords = allCoordinates[selectedProvinceId]?.[0] || params?.position;
      if (targetCoords && targetCoords.length) {
        map.flyTo(targetCoords, params?.zoom || 10); // Zoom level adjusted for province
      }
    }, [selectedProvinceId, map]);
    return null;
  }

  // Fly to City
  function FlyToCity({ selectedCityId }) {
    const map = useMap();
    useEffect(() => {

      const targetCoords = allCoordinates[selectedCityId]?.[0] || params?.position;
      if (targetCoords && targetCoords.length) {

        map.flyTo(targetCoords, params?.zoom || 12); // Zoom level adjusted for city
      }
    }, [selectedCityId, map]);
    return null;
  }
    // Fly to the new area and update marker
    function FlyToArea({ selectedAreaId }) {
      const map = useMap();
      useEffect(() => {
        const targetCoords =
          allCoordinates[selectedAreaId]?.[0] || params?.position;

          
        if (targetCoords &&targetCoords.length ) {
          map.flyTo(targetCoords, params?.zoom || 13);
           // Adjust zoom as needed
          // setClickedCoords(targetCoords); // Update marker position
        }
      }, [selectedAreaId, map]);
      return null;
    }
// Handle initial position update
useEffect(() => {
  if (params?.position?.length > 0 && params?.position[0] !== null && params?.position[1] !== null) {
    setClickedCoords(params?.position);
  } else if (!params?.isInCreateAdPage) {
    setClickedCoords([]);
  }
}, [params?.position, params?.isInCreateAdPage]);

  // useEffect(() => {
  //   if (params.position?.length > 0 && params.position[0] !== null && params.position[1] !== null) {
  //     setClickedCoords(params.position);
  //   }else{
  //     if (!params?.isInCreateAdPage){
  //       setClickedCoords([])
  //     }
  //   }
  // }, [params.position]);


  const platform = navigator.platform;

  // alert(platform);
  const toggleFullScreen = ()=>{
    setIsFullScreen(!isFullscreen)
   
    if (!isFullscreen) {
      document.body.classList.add("no-scroll"); // Prevent body scroll
    } else {
      document.body.classList.remove("no-scroll");
    }
    setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.invalidateSize();
      }
    }, 300); 
  }
  function ResizeMap({ fullscreen }) {
    const map = useMap();
    if (fullscreen) {
        setTimeout(() => {
            map.invalidateSize();
        }, 0);
    }
    return null;
}

useEffect(()=>{
  // setPolygonForMap(allCoordinates[params.selectedAreaId])
  setPolygonForMap(
    typeof allCoordinates[params.selectedAreaId] != "undefined"
      ? allCoordinates[params.selectedAreaId]
      : []
  );
},[params.selectedAreaId,params.position])
useEffect(() => {
  if (params.centerLatitude && params.centerLongitude && mapRef.current) {
    mapRef.current.flyTo([params.centerLatitude, params.centerLongitude], params?.zoom || 13);
  }
}, [params.centerLatitude, params.centerLongitude]);
function ChangeView({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (center[0] && center[1]) {
      map.setView(center, zoom);
    }
  }, [center, zoom, map]);
  return null;
}
  return (
    <div className={isFullscreen ? "map-w-single-marker map-container fullscreen fullscreen-map" :   `${ !params?.isInCreateAdPage && `map-container map-w-single-marker`} ${ params?.isInCreateAdPage && `h-[400px] mt-7 z-0`}  `}>
      <MapContainer
        className="custom-styles-index-map"
        // center={clickedCoords.length > 0 ? clickedCoords : [35.6892, 51.3890]} // Default to Tehran if no clickedCoords
        center={
          params.centerLatitude && params.centerLongitude
            ? [params.centerLatitude, params.centerLongitude]
            : clickedCoords.length > 0
            ? clickedCoords
            : [35.6892, 51.3890] // Default to Tehran if no coordinates are set
        }
        zoom={params?.zoom}
        scrollWheelZoom={true}
        wheelPxPerZoomLevel={100}
        whenCreated={(mapInstance) => (mapRef.current = mapInstance)} 
      >
        <div className={`${ !params?.isInCreateAdPage && `absolute bottom-0 left-0`}  z-index-important`}>



        </div>
        <MapClickHandler />
        <TileLayer
          attribution='&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
          // url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png"
          url = "http://{s}.tile.osm.org/{z}/{x}/{y}.png "    

          

        />
           <img
                className="absolute bg-white z-1000 top-3 right-2 w-[32px] border border-[2px] border-gray-900 border-opacity-40 rounded cursor-pointer"
                src="/icons/zoomOut.svg"
                alt="zoom"
                onClick={toggleFullScreen}
              />
  {/* {(clickedCoords.length  > 0 && clickedCoords[0]!==null && clickedCoords[1]!==null) && <Marker position={clickedCoords} />} */}
  {clickedCoords.length > 0 && <Marker position={clickedCoords} />}
        {/* {userCurrentLoc && <Marker position={userCurrentLoc} />} */}
        {/* {userLocation?.length > 0 && !params?.isApproximateArea ? (
          <Routing
            userLocation={userLocation}
            targetLocation={params?.position}
          />
        ) : params.isApproximateArea ? (
          <Circle center={params?.position} radius={250} />
        ) : <Marker position={params?.userCurrentLoc || params?.position} />} */}
          {polygonForMap.length > 0 && (
              <Polygon positions={polygonForMap} pathOptions={{
                color: "green", // Border color
                weight: 2,    // Border thickness (lower values make it thinner)
                opacity: 0.6, // Border transparency (lower values make it softer)
                fillOpacity: 0.1, // Transparency for the inside fill color
              }} />
            )}
         <ResizeMap fullscreen={isFullscreen} />
         <ChangeView
    center={[
      params.centerLatitude || clickedCoords[0],
      params.centerLongitude || clickedCoords[1],
    ]}
    zoom={params?.zoom || 13}
  />
  <FlyToProvince selectedProvinceId={params.selectedProvinceId} />
  <FlyToCity selectedCityId={params.selectedCityId} />
         <FlyToArea selectedAreaId={params.selectedAreaId} />
      </MapContainer>
      </div>
  );
}

export default MapWithSingleMarker;




// import React, { useEffect } from 'react';
// import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import L from 'leaflet';

// // Fix for the default marker icon
// delete L.Icon.Default.prototype._getIconUrl;

// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

// // This component will be used inside the MapContainer to zoom and pan to the user's location
// function RecenterMap({ userCurrentLoc }) {
//   const map = useMap();

//   useEffect(() => {
//     if (userCurrentLoc) {
//       map.setView(userCurrentLoc, 15); 
//     }
//   }, [userCurrentLoc, map]);

//   return null; // This component doesn't render anything on the map itself
// }

// function MapWithSingleMarker({ position, zoom, userCurrentLoc }) {
//   return (
//     <MapContainer
//       className="custom-styles-index-map"
//       center={position} // Initial center before user clicks current location
//       zoom={zoom}
//       scrollWheelZoom={false}
//     >
//       <TileLayer
//         attribution='&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
//         url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png"
//       />

//       {/* Recenter the map and zoom in on the user's current location */}
//       {userCurrentLoc && <RecenterMap userCurrentLoc={userCurrentLoc} />}
      
//       {/* Show marker at user's current location if available, else show it at the default position */}
//       <Marker position={userCurrentLoc || position} />
//     </MapContainer>
//   );
// }

// export default MapWithSingleMarker;
